import React, { useMemo, useState } from 'react';
import { Alert, Modal, Select } from 'antd';
import { applyDayOrder, moveDayOrder } from './scheduleDayOrder';
import { fmtDateShort } from './scheduleTimes';

export default function MoveDayDialog({ days, from, proposal = false, busy = false, error, onCancel, onMove }) {
  const [to, setTo] = useState(null);
  const preview = useMemo(() => to == null ? [] : applyDayOrder(days, moveDayOrder(days, from, to)), [days, from, to]);
  return <Modal open className="production-prototype" title={`Move ${proposal ? 'proposed ' : ''}Day ${from}`} onCancel={onCancel}
    maskClosable={!busy} closable={!busy} okText={proposal ? 'Confirm draft move' : 'Confirm and save'}
    okButtonProps={{ disabled: to == null || busy, loading: busy }} cancelButtonProps={{ disabled: busy }} onOk={() => onMove(from, to)}>
    {error && <Alert type="error" showIcon message={error} />}
    <label htmlFor="move-day-position">New position</label>
    <Select id="move-day-position" aria-label="New shooting day position" inputMode="none" className="pp-full" value={to} disabled={busy}
      placeholder="Choose day position" onChange={setTo} options={days.map((d, i) => ({ value: i + 1, label: `Day ${i + 1}`, disabled: d.dayNumber === from }))} />
    <p>{proposal ? 'Only the proposal changes. Manual Schedule and Calendar stay unchanged until approval.' : 'Save this shooting-day order? Scenes and all day details stay together; dates stay chronological.'}</p>
    <ol className="pp-move-day-preview">{preview.map(d => {
      const origin = days.find(x => x.entries === d.entries);
      return <li key={d.dayNumber}>Day {origin?.dayNumber} → Day {d.dayNumber} — {d.date ? fmtDateShort(d.date) : 'Undated'}</li>;
    })}</ol>
  </Modal>;
}